import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_114: FaireProductEntity = {
  token: "legacy_prod_abbott-114",
  type: "product",
  name: "Beehive Covered Pot",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/b83b2af49361328c8598d0c12575d9e81d90f8b005e38914cc57606f2904aa66.jpeg",
  priceDollars: 22,
  subcategory: "Serveware",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
